import _styled from "@emotion/styled-base";
import PropTypes from 'prop-types';
import Box from '../Box';
import { themeGet } from '@styled-system/theme-get';

var AppBarItem =
/*#__PURE__*/
_styled(Box, {
  target: "exolzbk0"
})("text-decoration:none;border-bottom:2px solid transparent;background:transparent;height:100%;font-weight:", function (props) {
  return props.isActive && 'bold';
}, ";&:hover{border-bottom-color:", function (props) {
  return !props.isActive && themeGet("colors.muted");
}, ";}border-bottom-color:", function (props) {
  return props.isActive && themeGet("colors.".concat(props.activeBorderColor));
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9BcHBCYXIvQXBwQmFySXRlbS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLOEIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL0FwcEJhci9BcHBCYXJJdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBCb3ggZnJvbSAnLi4vQm94JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHRoZW1lR2V0IH0gZnJvbSAnQHN0eWxlZC1zeXN0ZW0vdGhlbWUtZ2V0JztcblxuY29uc3QgQXBwQmFySXRlbSA9IHN0eWxlZChCb3gpYFxuICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gIGJvcmRlci1ib3R0b206IDJweCBzb2xpZCB0cmFuc3BhcmVudDtcbiAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gIGhlaWdodDogMTAwJTtcbiAgZm9udC13ZWlnaHQ6ICR7cHJvcHMgPT4gcHJvcHMuaXNBY3RpdmUgJiYgJ2JvbGQnfTtcbiAgJjpob3ZlciB7XG4gICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHtwcm9wcyA9PlxuICAgICAgIXByb3BzLmlzQWN0aXZlICYmIHRoZW1lR2V0KGBjb2xvcnMubXV0ZWRgKX07XG4gIH1cblxuICBib3JkZXItYm90dG9tLWNvbG9yOiAke3Byb3BzID0+XG4gICAgcHJvcHMuaXNBY3RpdmUgJiYgdGhlbWVHZXQoYGNvbG9ycy4ke3Byb3BzLmFjdGl2ZUJvcmRlckNvbG9yfWApfTtcbmA7XG5cbkFwcEJhckl0ZW0ucHJvcFR5cGVzID0ge1xuICBpc0FjdGl2ZTogUHJvcFR5cGVzLmJvb2wsXG59O1xuXG5BcHBCYXJJdGVtLmRlZmF1bHRQcm9wcyA9IHtcbiAgZm9udFNpemU6ICdib2R5JyxcbiAgbGluZUhlaWdodDogJ2JvZHknLFxuICBjb2xvcjogJ3RleHQnLFxuICBib3JkZXI6ICdub25lJyxcbiAgYWN0aXZlQm9yZGVyQ29sb3I6ICdwcmltYXJ5JyxcbiAgcHg6IDIsXG4gIHB5OiAzLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQXBwQmFySXRlbTtcbiJdfQ== */"));

AppBarItem.propTypes = {
  isActive: PropTypes.bool
};
AppBarItem.defaultProps = {
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text',
  border: 'none',
  activeBorderColor: 'primary',
  px: 2,
  py: 3
};
export default AppBarItem;